import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import './TokenSwap.css';

function TokenSwap() {
    const { t } = useTranslation();
    const iframeRef = useRef(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const handleMessage = (event) => {
            // 接收来自iframe的消息
            if (event.data === 'rango-widget-loaded') {
                setIsLoading(false);
            }
        };

        // 监听iframe消息
        window.addEventListener('message', handleMessage);

        // 设置超时，即使没收到消息也取消加载动画
        const timeout = setTimeout(() => {
            setIsLoading(false);
        }, 8000);

        return () => {
            window.removeEventListener('message', handleMessage);
            clearTimeout(timeout);
        };
    }, []);

    // 动画变体
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: { 
            opacity: 1,
            transition: { 
                delay: 0.1,
                duration: 0.5
            }
        }
    };

    return (
        <motion.div 
            className="token-swap-container"
            initial="hidden"
            animate="visible"
            variants={containerVariants}
        >
            <div className="feature-summary">
                <span>{t('multiChainSwap')}</span>
                <span>|</span>
                <span>{t('smartRouting')}</span>
                <span>|</span>
                <span>{t('securityGuarantee')}</span>
            </div>
            
            <div className="swap-widget-wrapper">
                <div className="rango-iframe-container">
                    <iframe 
                        ref={iframeRef}
                        src="/rango-widget.html"
                        title="Rango Widget"
                        className="rango-iframe"
                        allow="clipboard-write; camera; microphone; accelerometer; autoplay; encrypted-media; gyroscope; payment"
                        sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-modals allow-top-navigation"
                    />
                    
                    {isLoading && (
                        <div className="loading-placeholder">
                            <div className="loading-icon"></div>
                            <p>{t('loadingSwapComponent')}</p>
                            <p className="loading-tip">{t('walletPluginRequired')}</p>
                        </div>
                    )}
                </div>
            </div>
            
            <div className="token-swap-disclaimer">
                <p>{t('swapDisclaimer')}</p>
            </div>
        </motion.div>
    );
}

export default TokenSwap; 